export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName =
      favicon.dataset.badgeIcon || `/favicon-badge-${favicon.sizes[0]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName =
          favicon.dataset.defaultIcon || `/favicon-${favicon.sizes[0]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
